export default {
  accessError: 'access-error',
};
